<template>
  <div
    class="vs-modal"
    :dir="direction"
  >
    <button
      v-if="buttonText"
      ref="modalButton"
      :class="oninit_setButtonType(buttonType)"
      @click="onclick_openModal()"
    >
      {{ buttonText }} <span class="visa-icon visa-icon-outside-link" />
    </button>
    <div
      ref="modalContainer"
      class="vs-modal-container"
      :class="type + ' ' + (show ? '' : 'vs-modal-hide')"
      role="dialog"
      :aria-labelledby="'modal_header_' + computedId"
      @keydown.esc="closeModal()"
      @keydown.tab="ontab_trapFocus($event)"
    >
      <div class="vs-modal-header">
        <h2
          v-if="header"
          :id="'modal_header_' + computedId"
          ref="modalHeader"
          class="vs-h3"
          tabindex="-1"
        >
          {{ header }}
        </h2>
      </div>
      <div class="vs-modal-content">
        <slot />
      </div>
      <button
        class="visa-icon visa-icon-close vs-btn-close-modal"
        :aria-label="allyCloseLabel"
        @click="onclick_closeModal()"
      />
    </div>
    <div
      v-if="show"
      class="vs-modal-background"
      :class="type"
    />
  </div>
</template>

<script>
import { setDirection } from '@/helpers/direction';
import { generateId } from '@/helpers/generate-id';
import { trapFocus } from '@/helpers/trap-focus';
import { toBoolean } from '@/helpers/transform';

export default {
  name: 'VsModal',
  props: {
    id: { type: String, default: '' },
    buttonText: { type: String, default: '' },
    buttonType: { type: String, default: 'primary' },
    header: { type: String, default: '' },
    allyCloseLabel: { type: String, default: '' },
    showModal: { type: String, default: 'false' },
    type: { type: String, default: '' },
    enableCloseEvent: { type: String, default: 'false' },
    direction: { type: String, default: setDirection() },
  },
  data() {
    return {
      show: toBoolean(this.showModal),
      computedId: '',
    };
  },
  mounted() {
    this.computedId = this.id.length ? this.id : generateId().toString();

    if (toBoolean(this.enableCloseEvent)) {
      document.addEventListener('close_modal_' + this.computedId, () => {
        this.closeModal();
      });
    }
  },
  methods: {
    oninit_setButtonType(buttonType) {
      if (buttonType === 'link') {
        return 'vs-link-cta vs-link-modal';
      } else if (buttonType === 'inline-link') {
        return 'vs-link-cta vs-link-modal vs-link-inline';
      } else if (
        buttonType === 'primary' ||
        buttonType === 'secondary' ||
        buttonType === 'tertiary'
      ) {
        return `vs-btn vs-btn-${buttonType} vs-btn-icon vs-btn-open-modal`;
      } else {
        return 'vs-btn vs-btn-icon vs-btn-open-modal';
      }
    },
    onclick_openModal() {
      this.openModal();
    },
    onclick_closeModal() {
      this.closeModal();
    },
    ontab_trapFocus(e) {
      const container = this.$refs.modalContainer;

      trapFocus(container, e);
    },
    openModal() {
      this.show = !this.show;
      document.body.classList.add('vs-modal-body');

      this.$nextTick(() => {
        const header = this.$refs.modalHeader;

        header.focus();
      });
      this.$emit('openModal');
    },
    closeModal() {
      document.body.classList.remove('vs-modal-body');
      this.show = !this.show;

      this.$emit('closeModal');
      this.returnFocus();
    },
    returnFocus() {
      if (this.$refs.modalButton) {
        this.$refs.modalButton.focus();
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/modal/modal';
@import '@/styles/core/types/types';
@import '@/styles/buttons/buttons';
@import '@/styles/links/erclinks';
@import '@/styles/label';
@import '@/styles/grid';
@import '@/styles/utilities';
</style>
